"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SwitchStatus", {
  enumerable: true,
  get: function get() {
    return _SwitchStatus.SwitchStatus;
  }
});

var _SwitchStatus = require("./SwitchStatus.connect");